import './source/lib/lib.force-mobile-menu';

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

Number.isInteger = Number.isInteger || function (value) {
	return typeof value === "number" &&
		isFinite(value) &&
		Math.floor(value) === value;
}

/* 
 * Priority javascript
 *----------------------------------------------------------*/
// Check logged in
document.cookie.indexOf("vlId") >= 0 ? document.documentElement.classList.add("vl-loggedin") : document.documentElement.classList.remove("vl-loggedin");

// Check blur support
if (!(function () { var filterEl = document.createElement('div'); filterEl.style.cssText = 'filter:blur(2px)'; return filterEl.style.length != 0 && (document.documentMode === undefined || document.documentMode > 9); })()) { document.body.classList.add('blur-fallback') }

// Polyfill fetch support
!function () { if (window.MSInputMethodContext && document.documentMode) { var t = document.createElement("script"); t.type = "text/javascript", t.src = "https://cdn.jsdelivr.net/npm/promise-polyfill@8.1.3/dist/polyfill.min.js"; var e = document.createElement("script"); e.type = "text/javascript", e.src = "https://cdn.jsdelivr.net/npm/whatwg-fetch@3.4.0/dist/fetch.umd.min.js", document.head.appendChild(t), document.head.appendChild(e) } }();

(function () {

	// Class definition
	var User = function () {
		this._run()
	}


	User.prototype =
	{
		constructor: User

		/**
		 * Internal cache manager
		 * 
		 * @param 	string key The key the cache attribute is referred by
		 * @param 	void value = null Optionaly set the value to use the cache in a setter context
		 * @return 	void
		 */
		, cache: function (key, value) {
			if (typeof window.sessionStorage == 'undefined') {
				return null
			}

			// Encorporate vLid context into session storage; when user logs in or changes the context changes automaticly
			var scope = document.cookie.match(/vlId=([^;]+)/)
			scope = scope ? (function (s) { var h = 0, l = s.length, i = 0; if (l > 0) { while (i < l) { h = (h << 5) - h + s.charCodeAt(i++) | 0; } } return Math.abs(h); })(scope[1]) : 0

			key = scope + '-' + key

			if (value) {
				var _value = value

				if (typeof _value == 'object') {
					_value = JSON.stringify(_value)
				}

				window.sessionStorage.setItem(key, _value)
			}
			else {
				value = window.sessionStorage.getItem(key)

				try {
					value = value ? JSON.parse(value) : value
				}
				catch (e) {
					// Do nothing
					true;
				}
			}

			return value
		}

		/**
		 * Retrieve the user profile information
		 *
		 * @deprecated Use getUserInfo to get the gigya-id.
		 * @return	Promise
		 */
		, getProfile: function () {
			// Fetch profile trough request
			if (typeof this._profile != 'undefined') {
				return this._profile
			}

			var self = this


			return this._profile = new Promise(function (resolve, reject) {

				if (!self.isLoggedIn()) {
					return reject(new Error('User not logged in'));
				}

				var cache = self.cache('profile')

				if (cache !== null) {
					return resolve(cache)
				}

				fetch('https://www.videoland.com/api/v3/profiles')
					.then(response => response.json())
					.then(function (response) {
						if (response && typeof response.message != 'undefined') {
							return reject(new Error(response.message))
						}

						// Extract selected profile
						for (var i = 0; i < response.length; i++) {
							var profile = response[i]

							if (profile.is_selected) {
								resolve(window.user.cache('profile', profile))
							}
						}

						reject(new Error('Unable to find active profile'))
					})

					.catch(reject)
			})

		}

		/**
		 * Return the videoland user id (gigya id)
		 * 
		 * @return	Promise
		 */
		, getUserInfo: function () {
			if (typeof this._user != 'undefined') {
				return this._user
			}

			var self = this

			return this._user = new Promise(function (resolve) {

				if (!self.isLoggedIn()) {
					return resolve(false);
				}

				var cache = self.cache('user')

				if (cache !== null) {
					return resolve(cache)
				}

				// var headers = new Headers()
				// headers.append('content-type', 'application/json')

				// var request = {
				// 	method: 'POST',
				// 	headers: headers,
				// 	credentials: 'include',
				// 	body: JSON.stringify({ "query": "{ me { user { id } } }" }),
				// 	redirect: 'follow'
				// }

				// fetch("https://api.videoland.com/subscribe/videoland-account/graphql", request)
				// 	.then(response => response.json())

				// 	// Validate response
				// 	.then(function (response) {
				// 		if (typeof response.data != 'undefined' && typeof response.data.me != 'undefined' && typeof response.data.me.user != 'undefined') {
				// 			resolve(window.user.cache('user', response.data.me.user.id))
				// 		}
				// 		else {
				// 			resolve(false)
				// 		}
				// 	})

				// 	// Simply fallback on false state
				// 	.catch(function () {
				// 		resolve(false)
				// 	})
				resolve (false)
			})
		}

		/**
		 * Return the visitors tier information
		 *
		 * @return	Promise
		 */
		, getTier: function () {
			if (typeof this._tier != 'undefined') {
				return this._tier
			}

			var self = this

			return this._tier = new Promise(function (resolve) {

				if (!self.isLoggedIn()) {
					return resolve(false);
				}

				var cache = self.cache('tier')

				if (cache !== null) {
					return resolve(cache)
				}

				// var headers = new Headers()
				// headers.append('content-type', 'application/json')

				// var request = {
				// 	method: 'POST',
				// 	headers: headers,
				// 	credentials: 'include',
				// 	body: JSON.stringify({ "query": "{ me { tier { id } } }" }),
				// 	redirect: 'follow'
				// }

				// fetch("https://api.videoland.com/subscribe/subscription/graphql", request)
				// 	.then(response => response.json())

				// 	// Validate response
				// 	.then(function (response) {
				// 		if (typeof response.data != 'undefined' && typeof response.data.me != 'undefined' && typeof response.data.me.tier != 'undefined') {
				// 			resolve(window.user.cache('tier', response.data.me.tier.id))
				// 		}
				// 		else {
				// 			resolve(false)
				// 		}
				// 	})

				// 	// Simply fallback on false state
				// 	.catch(function () {
				// 		resolve(false)
				// 	})
				resolve(false)
			})
		}

		/**
		 * Return wether the user is logged in
		 * 
		 * @return 	bool
		 */
		, isLoggedIn: function () {
			return document.cookie.indexOf('vlId') >= 0
		}

		/**
		 * Fetch user information
		 * 
		 */
		, _run: function () {
			window.dataLayer = window.dataLayer || []

			var self = this

			self.getUserInfo()
				.then(function (id) {
					self.getTier().then(function (tier) {

						window.dataLayer.push({
							event: 'loginStatus'

							, loggedIn: true
							, tier: tier
							, 'gigya-id': id
						})

					})
						.catch(function (e) {
							throw e
						})
				})

				// Fall back on non logged in state
				.catch(function () {
					window.dataLayer.push({
						event: 'loginStatus'

						, loggedIn: self.isLoggedIn()
						, tier: false
					})
				})


		}
	}

	// Run interface
	window.user = new User()


})();

(function () {

	// --------------------------------------------------------------------------------------------
	// Track scroll

	var Scroll = function () {
		window.dataLayer = window.dataLayer || []
		this._sections = document.querySelectorAll('.et_pb_column > header, .et_pb_column > section, footer.vl-footer')
	}

	Scroll.prototype =
	{
		constructor: Scroll

		/**
		 * Return the position of the element
		 * 
		 * @param 	node elem The contextual element to calculate the position of
		 * @return 	int
		 */
		, _calcTopPosition(elem) {
			var offset = 0;

			do {
				if (!isNaN(elem.offsetTop)) {
					offset += elem.offsetTop;
				}
			} while (elem == elem.offsetParent)

			return offset

		}

		/** 
		 * Return the visible / focused section
		 * 
		 * @return	Node
		 */
		, _getVisibleSection: function () {
			// offset scroll position for reading position
			let offset = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
			offset = offset ? offset * 0.75 : 0


			var pos = window.pageYOffset + document.querySelector('nav[role="navigation"]').offsetHeight
			pos += offset

			for (var i = this._sections.length - 1; i > 0; i--) {
				if (pos > this._calcTopPosition(this._sections[i])) {
					break;
				}
			}

			return [this._sections[i], i]
		}

		/**
		 * Observe the scroll event
		 * 
		 * @param	Event e The event being processed
		 */
		, _observeScroll: function () {
			// Menu background
			if (window.pageYOffset > 40) {
				document.querySelector('nav[role="navigation"]').classList.add('solid-bg')
			}
			else {
				document.querySelector('nav[role="navigation"]').classList.remove('solid-bg')
			}

			// Tracking
			// var section = this._getVisibleSection()

			// this.trackScroll( section[0], section[1] )
		}

		/**
		 * Track the specified section 
		 * 
		 */
		, trackScroll: function (section, index) {
			if (index >= 1) {
				this.trackScroll(this._sections[index - 1], index - 1)
			}

			if (section.classList.contains('tracked')) {
				return;
			}

			section.classList.add('tracked')

			var title = section.tagName == 'FOOTER' ? 'Footer' : ''
			title = !title && section.classList.contains('vl-quicknav') ? 'TOC' : title

			if (!title) {
				title = section.querySelector('h1,h2,h3,h4')
				title = title ? title.innerText : false

				title = title ? title.replace("\n", ' ') : title
			}

			window.dataLayer.push({
				event: 'scroll',
				position: Math.floor((this._calcTopPosition(section) * 100) / document.body.offsetHeight),
				section: title,
				sectionPos: index
			})
		}
	}

	// Initinalize scrollspy
	var scrollSpy = new Scroll();

	/**
	 * Initialize javascript to check menu state
	 */

	window.checkScroll = () => {
		scrollSpy._observeScroll();
	}

	window.checkScroll();

})();
